import React, { useState } from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Button, Collapsible } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import { useStateMachineContext } from '@common/context/StateMachineContext';

import { TENANT_CONFIG, LANDLORD_CONFIG, TENANT_ROLE } from '../../constants';

import ContactUsHeader from '../ContactUsHeader';
import './ContactSections.scss';

const getSectionsFromParams = (role, category) => {
  const categories = role === TENANT_ROLE ? TENANT_CONFIG : LANDLORD_CONFIG;
  return Object.entries(categories[category]);
};

const ContactSections = () => {
  const [sectionOpen, setSectionOpen] = useState('');

  const { payload, send } = useStateMachineContext();
  const { role, categoryId } = payload;

  const formSections = getSectionsFromParams(role, categoryId);
  const baseLocoKey = `contact-us.${role}`;

  const handleSectionAccordionClick = sectionId => {
    if (sectionId !== sectionOpen) {
      setSectionOpen(sectionId);
    }
  };

  const handleItemClick = (sectionId, reasonId) => {
    Metrics.ga.sendEvent(
      'contact_form_revamp',
      'reason_clicked',
      `${reasonId}`
    );
    send('SELECT', { sectionId, reasonId });
  };

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader
        title={trans(`${baseLocoKey}.${categoryId}`)}
        onBack={() => send('BACK')}
      />
      {formSections.map(([sectionId, reasons]) => (
        <Collapsible
          key={sectionId}
          isCollapsed={sectionId !== sectionOpen}
          onCollapsedChange={() => handleSectionAccordionClick(sectionId)}
          isRounded
          hasIcon
          className="contact-subcategories__accordion"
          headerClassName="contact-subcategories__header"
          bodyClassName="contact-subcategories__body"
          renderHeader={() => trans(`${baseLocoKey}.${sectionId}`)}
          renderBody={() => (
            <ul className="contact-subcategories__list">
              {reasons.map(reasonId => (
                <li key={reasonId}>
                  <Button
                    color="primary"
                    size="large"
                    alt
                    fullWidth
                    onClick={() => handleItemClick(sectionId, reasonId)}
                    className="contact-us-form__button--alt"
                  >
                    {trans(`${baseLocoKey}.${reasonId}`)}
                  </Button>
                </li>
              ))}
            </ul>
          )}
        />
      ))}
    </div>
  );
};

export default ContactSections;
